import React from 'react';

import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const SelectedCheck: React.FC<{ selected: boolean }> = ({ selected }) => {
  if (!selected) {
    return null;
  }

  return (
    <>
      {' '}
      <FontAwesomeIcon icon={faCheck} title="Current" aria-label="Current" />
    </>
  );
};
